import chroma from "chroma-js";
import React, { useState } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";

export default function TextContrastChecker({ colorHex, colorName, locale }) {
  const [color, setColor] = useState("#222233");
  const contrast = chroma.contrast(color, colorHex);

  return (
    <div
      style={{
        display: "flex",
        gap: "1rem",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <div>
        <strong style={{ margin: "1rem 0", display: "block" }}>
          {locale === "es"
            ? `Cambiar el color de fondo`
            : locale === "en"
            ? `Change the background color`
            : locale === "pt"
            ? `Alterar a cor de fundo`
            : locale === "fr"
            ? `Changer la couleur de fond`
            : locale === "de"
            ? `Hintergrundfarbe ändern`
            : ""}
        </strong>
        <div>
          <HexColorPicker color={color} onChange={setColor} />
          <HexColorInput color={color} onChange={setColor} />
        </div>

        <div style={{ display: "flex", alignItems: "center", margin: "0 0" }}>
          <strong>
            {locale === "es"
              ? `Relación de contraste: ${contrast.toFixed(2)}`
              : locale === "en"
              ? `Contrast ratio: ${contrast.toFixed(2)}`
              : locale === "pt"
              ? `Relação de contraste: ${contrast.toFixed(2)}`
              : locale === "fr"
              ? `Relation de contraste: ${contrast.toFixed(2)}`
              : locale === "de"
              ? `Kontrastverhältnis: ${contrast.toFixed(2)}`
              : ""}
          </strong>
          <svg
            fill={contrast > 4.6 ? "green" : "red"}
            height="24"
            viewBox="0 0 20 24"
            width="34"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m4 21h1v-13h-1c-1.104 0-2 .896-2 2v9c0 1.104.896 2 2 2zm16-13h-7l1.122-3.368c.432-1.295-.532-2.632-1.897-2.632h-.225l-5 5.438v13.562h11l3.912-8.596c.025-.113.064-.29.088-.404v-2c0-1.104-.896-2-2-2z" />
          </svg>
        </div>
      </div>

      <div
        style={{
          backgroundColor: color,
          height: "210px",
          width: 200,
          borderRadius: 8,
          padding: "1rem",
        }}
      >
        <p style={{ color: colorHex }}>
          <small>
            {locale === "es"
              ? `Prueba de contrast ratio del color ${colorName} como texto`
              : locale === "en"
              ? `Contrast ratio test of the color ${colorName} as text.`
              : locale === "pt"
              ? `Teste de relação de contraste da cor ${colorName} como texto.`
              : locale === "fr"
              ? `Test du rapport de contraste de la couleur ${colorName} en tant que texte`
              : locale === "de"
              ? `Kontrastverhältnis-Test der Farbe ${colorName} als Text.`
              : ""}
          </small>
        </p>
      </div>
    </div>
  );
}
